module.exports = __webpack_public_path__ + "img/skull_9.0241b9e6.png";